import { render, staticRenderFns } from "./custom-company-component-new.vue?vue&type=template&id=8412220a&scoped=true&"
import script from "./custom-company-component-new.vue?vue&type=script&lang=js&"
export * from "./custom-company-component-new.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-component-new.vue?vue&type=style&index=0&id=8412220a&scoped=true&lang=scss&"
import style1 from "./custom-company-component-new.vue?vue&type=style&index=1&id=8412220a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8412220a",
  null
  
)

export default component.exports